import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const flexCenter = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const useHeaderStyles = makeStyles({
  container: {
    ...flexCenter,
    flexDirection: 'column',
    width: '100%',
    backgroundColor: tokens.colorNeutralBackground3,
    ...shorthands.padding(
      tokens.spacingVerticalXXL,
      tokens.spacingHorizontalNone,
      tokens.spacingVerticalXXL,
      tokens.spacingHorizontalNone,
    ),
  },
  row: {
    ...flexCenter,
  },
  avatar: {
    ...flexCenter,
    ...shorthands.margin(
      tokens.spacingHorizontalL,
      tokens.spacingHorizontalXL,
      tokens.spacingHorizontalL,
      tokens.spacingHorizontalXL,
    ),
    cursor: 'pointer',
  },
});
